import {HarRequest} from './harRequest';
import {HarResponse} from './harResponse';
import {HttpRequest, HttpResponse} from '@angular/common/http';
import {HarService} from '../services/har.service';

export class HarEntry {
    pageref: string;
    startedDateTime: Date;
    request: HarRequest;
    response: HarResponse;

    constructor(harService: HarService, request: HttpRequest<any>, response: HttpResponse<any>) {
      this.pageref = 'app';
      this.startedDateTime = new Date();
      this.request = new HarRequest(request);
      if (harService.includeResponses) {
        this.response = new HarResponse(response, request.detectContentTypeHeader());
      }
    }
}
